// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/_is-array.js
// module id = 73
// module chunks = 3 4 5 6 22 23 24 25 26 27 28 29 30 31 34 35 36 37 38 39 40 42 43 44 45 47